<div mat-dialog-title>
  <mode-dialog-header>
    <h1 heading>Add Members</h1>
    <mode-accessor-search
      [spaceId]="collectionId"
      [orgName]="workspaceName"
      [disabled]="isSaving$ | async"
      sub-heading></mode-accessor-search>
  </mode-dialog-header>
</div>
<div mat-dialog-content *ngIf="(selectedResults$| async) as entitlements;">
  <mode-alert-banner [message]="modeAlert"></mode-alert-banner>
  <ng-template [ngIf]="(isSaving$ | async) === false" [ngIfElse]="savingEl">
    <div *ngIf="entitlements.length; else emptyList">
      <mat-list class="collection-access-list">
        <mat-list-item *ngFor="let entitlement of entitlements">
          <mode-accessor-name
            [avatar]="entitlement.avatar"
            [link]="entitlement.webLink"
            [name]="entitlement.name"
            [type]="entitlement.type"></mode-accessor-name>
          <mode-access-selector [selected]="entitlement.action"
                                (selection)="entitlementChange($event, entitlement)"></mode-access-selector>
          <button class="remove-button" mat-icon-button (click)="removeSelectedEntitlement(entitlement)"
                  aria-label="remove accessor">
            <capra-icon icon="icon-close"></capra-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </div>
    <ng-template #emptyList>
      <div class="empty-list">
        <p>Members you select will appear here.</p>
      </div>
    </ng-template>
  </ng-template>
  <ng-template #savingEl>
    <div class="accessor-saving">
      <capra-icon class="loading-illustration" icon="illo-add-members-loading" width="312px" height="120px"></capra-icon>
      <h2>Adding Members...</h2>
      <p>This may take a few moments</p>
    </div>
  </ng-template>
</div>
<div mat-dialog-actions>
  <span class="actions-back">
    <capra-button
      text="Back"
      icon="icon-chevron-left"
      variant="secondary"
      color="neutral"
      [disabled]="isSaving$ | async"
      (click)="handleDone()"
    ></capra-button>
  </span>
  <capra-button
    class="action-add-members"
    text="Add Members"
    [disabled]="addEntitlementsDisabled$ | async"
    (click)="addEntitlements()"
  ></capra-button>
</div>
